import { Database, Lock, HelpCircle } from "lucide-react";

export type ForumType = "database" | "ransomware" | "unknown";

interface ForumTypeBadgeProps {
  type: ForumType;
}

const styleMap: Record<ForumType, { bg: string; color: string; border: string; text: string; icon: React.ComponentType<{ size?: number | string }> }> = {
  database: {
    bg: "rgba(59,130,246,0.12)",
    color: "#3b82f6",
    border: "1px solid rgba(59,130,246,0.25)",
    text: "Database Forum",
    icon: Database,
  },
  ransomware: {
    bg: "rgba(239,68,68,0.12)",
    color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.25)",
    text: "Ransomware Blog",
    icon: Lock,
  },
  unknown: {
    bg: "rgba(255,255,255,0.06)",
    color: "rgba(255,255,255,0.6)",
    border: "1px solid rgba(255,255,255,0.1)",
    text: "Unknown Source",
    icon: HelpCircle,
  },
};

export default function ForumTypeBadge({ type }: ForumTypeBadgeProps) {
  const s = styleMap[type] || styleMap.unknown;
  const Icon = s.icon;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        background: s.bg,
        color: s.color,
        border: s.border,
        borderRadius: 999,
        padding: "3px 10px",
        fontSize: "0.72rem",
        fontWeight: 600,
        letterSpacing: "0.03em",
      }}
    >
      <Icon size={12} />
      <span>{s.text}</span>
    </span>
  );
}
